import type { DispatchListItem } from './api/dispatchApi'

export type HomeActionPriority = 'high' | 'medium'

export type HomeActionItem = {
  id: string
  priority: HomeActionPriority
  dispatch: DispatchListItem
}

function byUpdatedDesc(a: DispatchListItem, b: DispatchListItem): number {
  return (b.updated_at || '').localeCompare(a.updated_at || '')
}

/** Max 5: semua draft (terbaru dulu), lalu dispatched (terbaru dulu). */
export function buildHomeActions(items: DispatchListItem[], limit = 5): HomeActionItem[] {
  const drafts = items.filter((i) => i.status === 'draft').sort(byUpdatedDesc)
  const dispatched = items.filter((i) => i.status === 'dispatched').sort(byUpdatedDesc)
  const ordered = [
    ...drafts.map((dispatch) => ({ id: dispatch.id, priority: 'high' as const, dispatch })),
    ...dispatched.map((dispatch) => ({
      id: dispatch.id,
      priority: 'medium' as const,
      dispatch,
    })),
  ]
  return ordered.slice(0, limit)
}

export function countDispatchStatuses(items: DispatchListItem[]): {
  draft: number
  dispatched: number
} {
  let draft = 0
  let dispatched = 0
  for (const item of items) {
    if (item.status === 'draft') draft += 1
    else if (item.status === 'dispatched') dispatched += 1
  }
  return { draft, dispatched }
}
